import { MediumText } from 'src/global.styles/typography.styles'
import styled from 'styled-components/macro'

export const ClearDateRange = styled(MediumText)`
  cursor: pointer;
  text-decoration: underline;
`

export const ClearDateRangeContainer = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
`
